import { TIncident, TUSubcategories } from "./types";

import * as IconsLibrary from '../components/Global/Icons/Library';
import { mappedCategoriesBySection } from "../utils/constants/categories";

/**
 * Description: Receives the data by the service and returns
 * a cleaned up object to be used by the IncidentCard and the
 * Detail view page;
 * 
 * @param data datum object returned by service
 * @returns 
 */
export const serializeIncident = (data: TIncident[]) => {
    if (data) {

        const incidentList = data?.map((data) => {
            return {
                categoryTitle: data?.business_service?.display_value,
                incidentId: data?.sys_id.value,
                incidentTitle: data?.short_description.display_value,
                incidentDescription: data?.description.display_value,
                section: data?.u_nova_section?.display_value ?? '',
                lat: data?.u_latitude.value,
                lng: data?.u_longitude.value,
                statusLevel: parseInt(data?.state.value),
                icon: mappedCategoriesBySection(data?.u_nova_section?.value).find(
                    (category) => category.id === data.business_service?.value
                )?.icon as IconsLibrary.LibraryTypes,
                date: data?.sys_updated_on.value,
                watchListId: data?.watch_list.value,
                openedBy: data?.opened_by.value,
                callerId: data?.caller_id.value,
            };
        });

        return incidentList;
    }
};


/**
 * Description: Receives the data by the service and returns
 * a cleaned up object to be used at step 2 dropdown menu
 * 
 * @param data datum object returned by service
 * @returns 
 */
export const serializeSubCategories = (data: TUSubcategories[]) => {
    if (data) {

        const subCategory = data?.map((data) => {
            return {
                id: data?.u_category.value,
                value: data?.u_category.display_value,
            };
        });

        return subCategory;
    }
};
